import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { func } from 'prop-types';

import { updateBODStep } from 'actions/clz/0bod';
import Button from 'components/common/Button';
import { sendGAEvent } from 'utils/ga';
import history from '../../../../history';
import { STEPS, STEP_NAME } from '../constant';
import s from './styles.css';

class NewUserRejectOffer extends React.PureComponent {
  componentDidMount() {
    sendGAEvent(
      'Visit_Page',
      'New_Customer_No_Offer_Page',
      'ACL_0BOD_New_Customer_No_Offer',
    );
  }

  goBack = () => {
    sendGAEvent('Tap_Back', 'Back_Button', 'ACL_0BOD_New_Customer_No_Offer');
    this.props.goToHome();
  };

  render() {
    return (
      <div className={s.container}>
        <div className={s.logoWrapper}>
          <img
            src="../images/song-vui-3x.png"
            className={s.logo}
            alt="Sống vui cùng HomeCredit"
          />
        </div>
        <div className={s.content}>
          <img
            className={s.image}
            src="images/failed.png"
            alt="Không tìm thấy hợp đồng"
          />
          <p className={s.title}>
            Hợp đồng <strong>bị huỷ/ từ chối</strong>
          </p>
          <p className={s.desc}>
            Hợp đồng vay tiền mặt của quý khách đã bị huỷ/ từ chối. Cảm ơn quý
            khách đã quan tâm
          </p>
        </div>
        <Button className={s.goHome} onClick={this.goBack}>
          Trở về trang chính
        </Button>
      </div>
    );
  }
}

NewUserRejectOffer.propTypes = {
  goToHome: func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  goToHome: () => {
    dispatch(updateBODStep(STEPS.START_LOAN));
    history.push(STEP_NAME[STEPS.START_LOAN]);
  },
});
const enhance = compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withStyles(s),
);

export default enhance(NewUserRejectOffer);
